export default __webpack_public_path__ + "static/media/chords.14f6ace6.png";